import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const stateFrom = location.state?.from?.pathname;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const destinationFor = (u) => {
    if (u && (u.role === "admin" || u.role === "moderator")) return "/admin";
    if (u && u.role === "wali") return "/wali";
    return stateFrom || "/matches";
  };

  React.useEffect(() => {
    if (user && typeof user === "object") navigate(destinationFor(user), { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      navigate(destinationFor(u), { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16 animate-fade-up" data-testid="login-page">
      <div className="eyebrow">Velkommen tilbage</div>
      <h1 className="mt-3 font-serif text-4xl text-olive-700">Log ind for at fortsætte</h1>
      <p className="mt-3 text-brown-600 text-sm">
        Indtast dine oplysninger for at vende tilbage til din Find Your Naseeb-konto.
      </p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <label className="block text-sm mb-1 text-brown-600">E-mail</label>
          <input data-testid="login-email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" placeholder="dig@eksempel.dk" />
        </div>
        <div>
          <label className="block text-sm mb-1 text-brown-600">Adgangskode</label>
          <input data-testid="login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field" placeholder="••••••••" />
        </div>
        {err && (
          <div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-xl px-4 py-2" data-testid="login-error">{err}</div>
        )}
        <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="login-submit">
          {busy ? "Logger ind…" : "Log ind"}
        </button>
      </form>

      <div className="mt-4 text-sm">
        <Link to="/forgot-password" className="text-olive-600 hover:underline" data-testid="forgot-password-link">
          Glemt adgangskode?
        </Link>
      </div>

      <div className="mt-6 text-sm text-brown-500">
        Ny her?{" "}
        <Link to="/register" className="text-olive-600 hover:underline" data-testid="register-link-from-login">
          Opret din profil
        </Link>
      </div>
    </div>
  );
}
